import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityHasSubcomponentsCard,
  EntityLinksCard,
  EntitySwitch,
} from '@backstage/plugin-catalog';
import {
  EntityCatalogGraphCard,
} from '@backstage/plugin-catalog-graph';
import {
  EntitySoundcheckCard,
} from '@spotify/backstage-plugin-soundcheck';
import { EntitySonarQubeCard } from '@backstage-community/plugin-sonarqube';
import { isSonarQubeAvailable } from '@backstage-community/plugin-sonarqube-react';
import {
  EntityNewRelicDashboardCard,
  isNewRelicDashboardAvailable,
} from '@backstage-community/plugin-newrelic-dashboard';
import { DefaultRenderNode } from '../nodes/DefaultRenderNode';
import { entityWarningContent } from './EntityWarningContent';

export const overviewContent = (
  <Grid container spacing={3} alignItems="stretch">
    {entityWarningContent}
    <Grid item md={6} data-intercom-target="entity-page-overview">
      <EntityAboutCard variant="gridItem" />
    </Grid>
    <Grid item md={6} xs={12} data-intercom-target="entity-page-overview-graph">
      <EntityCatalogGraphCard
        variant="gridItem"
        height={400}
        renderNode={DefaultRenderNode}
      />
    </Grid>

    <EntitySwitch>
      <EntitySwitch.Case if={isSonarQubeAvailable}>
        <Grid item md={6} data-intercom-target="entity-page-overview-sonarqube">
          <EntitySonarQubeCard variant="gridItem" />
        </Grid>
      </EntitySwitch.Case>
      <EntitySwitch.Case if={isNewRelicDashboardAvailable}>
        <Grid item md={6} xs={12}>
          <EntityNewRelicDashboardCard />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <Grid
      item
      md={6}
      xs={12}
      data-intercom-target="entity-page-overview-soundcheck"
    >
      <EntitySoundcheckCard />
    </Grid>
    <Grid item md={4} xs={12}>
      <EntityLinksCard />
    </Grid>
    <Grid item md={8} xs={12}>
      <EntityHasSubcomponentsCard variant="gridItem" />
    </Grid>
  </Grid>
);
